angular.module('tgaAdmin').controller('AccountController', [
  '$scope',
  '$state',
  '$window',
  '$cookies',
  '$sce',
  '$filter',
  '$uibModal',
  '$location',
  '$timeout',
  'userService',
  'productService',
  'settingsService',
  'constants',
  'domainService',
  'supportService',
  'authService',
  'accountService',
  'tzService',
  'orderService',
  '$translate',
  function (
    $scope,
    $state,
    $window,
    $cookies,
    $sce,
    $filter,
    $uibModal,
    $location,
    $timeout,
    userService,
    productService,
    settingsService,
    constants,
    domainService,
    supportService,
    authService,
    accountService,
    tzService,
    orderService,
    $translate,
  ) {
    $scope.data = {
      alerts: [],
      isSSO: true,
      products: [],
      taxRate: 0,
      salesTax: 0,
      adminPrice: 499,
      playerPrice: 500,
      svcPlanPrice: 2500,
      isAdmin: userService.checkUserType(['admin', 'super_admin', 'support_admin', 'sales_admin']),
      isSalesAdmin: userService.checkUserType(['sales_admin']),
      screen: 'address',
      countries: constants.countries,
      states: constants.states,
      games: [],
      bundles: [],
      addons: [],
    };

    $scope.viewmodel = {
      user: {},
      userLoaded: false,
      stats: {},
      password: null,
      confirmPassword: null,
      agreement_id: null,
      api_key: null,
      admins: 0,
      players: 0,
      company: null,
      address: null,
      city: null,
      state: null,
      zip_code: null,
      country: 'US',
      phone: null,
      code: null,
      plan: null,
      games: [],
      subscription: {},
      subscription_future: null,
      products: [],
      service_plan: false,
      tax: 0,
      transaction: {
        code: null,
        customerCode: null,
      },
      addons: [],
    };

    $scope.promo = {
      code: null,
      description: null,
      discount: null,
      final_price: null,
      type: null,
    };

    $scope.timezones = tzService.getTimezones();

    $scope.initialize = function () {
      $scope.loading = true;

      settingsService.getSettings().then((settings) => {
        $scope.data.isSSO = settings.is_sso;
      });

      userService.getUser(userService.getUserData().id).then((user) => {
        delete user.domains;
        $scope.viewmodel.user = user;
        $scope.viewmodel.userLoaded = true;
      });

      // set the subscription tab to be active if you clicked a game that was disabled
      // eslint-disable-next-line no-unused-expressions
      // TTA-1298: Also need to look for query params from v2
      const urlParams = new URLSearchParams($window.location.search);
      if ($state.params.tab === 'subscriptions' || urlParams.get('tab') === 'subscriptions') {
        $scope.active = 1;
      } else {
        $scope.active = 0;
      }

      domainService.getDomain().then((domain) => {
        $scope.viewmodel.company = domain.company_name;
        $scope.viewmodel.address = domain.company_address;
        $scope.viewmodel.city = domain.company_city;
        $scope.viewmodel.state = domain.company_state;
        $scope.viewmodel.zip_code = domain.company_zip_code;
        $scope.viewmodel.country = domain.company_country || 'US';
        $scope.viewmodel.phone = domain.company_phone;
      });

      domainService.getSubscription().then((subscription) => {
        $scope.viewmodel.subscription = subscription;
        $scope.actions.getProducts();
      });

      domainService.getSubscriptions().then((subscriptions) => {
        subscriptions.forEach((sub) => {
          if (sub.period === 'future' && $scope.viewmodel.subscription_future === null) {
            $scope.viewmodel.subscription_future = sub;
          }
        })
      });

      domainService.getDomainStats(true).then((stats) => {
        $scope.viewmodel.stats = stats;
      });

      supportService.getAgreement().then((agreement) => {
        $scope.viewmodel.agreement_id = agreement.agreement_id;
      });

      $scope.viewmodel.api_key = authService.getAuthentication().token;

      const matches = domainService.api.match(/^(?:https?:)?(?:\/\/)?([^/?]+)/i);
      $scope.data.api_doc = matches && `${matches[0]}/documentation/`;
    };

    $scope.actions = {
      submit(form) {
        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        if (form.$name === 'passwordForm' && $scope.viewmodel.password !== $scope.viewmodel.confirmPassword) {
          $scope.actions.createAlert(
            // eslint-disable-next-line max-len
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.password_no_match')
              .toString()}`,
            'danger',
          );
          return;
        }

        form.processing = true;
        const isPasswordForm = form.$name === 'passwordForm';
        const data = isPasswordForm ? { password: $scope.viewmodel.password } : $scope.viewmodel.user;

        if (isPasswordForm) {
          userService.updateUserPassword(data).then(
            (response) => {
              let auth = authService.clearAuthentication();
              auth.isAuth = true;
              auth.token = response;
              authService.setAuthentication(auth);
              $scope.viewmodel.api_key = response;

              userService
                .getCurrentUser()
                .then((user) => {
                  auth = authService.getAuthentication();
                  auth.isAuth = true;
                  auth.username = user.username;
                  auth.token = response;
                  auth.userId = user.id;
                  authService.setAuthentication(auth);
                  userService.setUser(user);
                  $state.go('v1.account', {
                    tab: 'profile',
                  });
                })
                .catch(() => {
                  authService.clearAuthentication();
                  $state.go('v1.login');
                });
              $scope.actions.createAlert(
                `<span class="fa fa-check"></span> ${$translate
                  .instant('account.password_updated_success')
                  .toString()}`,
                'success',
              );
              form.processing = false;
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              form.processing = false;
            },
          );
        } else {
          userService.updateUser(data, true).then(
            () => {
              $scope.actions.createAlert(
                `<span class="fa fa-check"></span> ${$translate.instant('account.account_updated_success').toString()}`,
                'success',
              );
              form.processing = false;
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              form.processing = false;
            },
          );
        }
      },
      add1Admin() {
        $scope.viewmodel.admins += 1;
      },
      sub1Admin() {
        if ($scope.viewmodel.admins > 0) {
          $scope.viewmodel.admins -= 1;
        }
      },
      add500Players() {
        $scope.viewmodel.players += 1;
      },
      sub500Players() {
        if ($scope.viewmodel.players >= 1) {
          $scope.viewmodel.players -= 1;
        }
      },
      resetPromo() {
        $scope.promo = {
          code: null,
          description: null,
          discount: null,
          final_price: null,
          type: null, // 1 = percentage, 2 = fixed, 3 = trial, 4 = paid, 5 = partner
        };
      },
      checkCoupon() {
        $scope.loading = true;

        accountService
          .checkCoupon(
            $scope.viewmodel.code,
            $scope.viewmodel.plan?.product_id,
            $scope.viewmodel.admins,
            $scope.viewmodel.players,
            $scope.viewmodel.service_plan,
          )
          .then(
            (response) => {
              $scope.loading = false;
              $scope.promo = response;

              if ($scope.promo.admins > 0) {
                $scope.viewmodel.admins = $scope.promo.admins;
              }

              $scope.actions.createAlert($translate.instant('common.activation_code_applied').toString(), 'success');
            },
            (err) => {
              $scope.loading = false;
              $scope.actions.createAlert(err.message, 'danger');
            },
          );
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
      clearAlerts() {
        $scope.data.alerts = [];
      },
      goToAddress() {
        $window.scrollTo(0, 0);
        $scope.data.screen = 'address';
      },
      goToPurchase(addressForm) {
        $scope.actions.clearAlerts();
        addressForm.submitted = true;

        if (addressForm.$invalid) {
          return;
        }

        const changeToPurchasePage = () => {
          $window.scrollTo(0, 0);
          $scope.data.screen = 'purchase';
        };

        // Try to post the transaction then return the data we get back.
        $scope.avataxLoading = true;
        addressForm.state.$invalid = false;
        const transactionData = {
          ...$scope.viewmodel.user,
          ...$scope.viewmodel,
          final_price: $scope.promo.final_price,
          discount: $scope.promo.discount,
        };
        orderService.postTransaction(transactionData).then(
          (transaction) => {
            $scope.avataxLoading = false;
            // Parse the transaction JSON.
            transaction = angular.fromJson(transaction.data);

            // Update the tax rate.
            $scope.data.taxRate = transaction.summary[0].rate || 0;

            // Save a copy of the relevant transaction fields.
            $scope.viewmodel.transaction = {
              code: transaction.code, // adjust the transaction with this code
              customerCode: transaction.customerCode, // and this customer code
            };

            changeToPurchasePage();
          },
          (err) => {
            $scope.avataxLoading = false;

            // $log.log('error encountered... ', err);

            if (err && err.message) {
              if (err.message.indexOf("'region'") > -1) {
                err.message = err.message.replace("'region'", "'state'");
                addressForm.state.$invalid = true;
              } else if (err.message.indexOf('state') > -1 && err.message.indexOf('postal code') > -1) {
                err.message = err.message.replace("'postal code'", "'zip code'");
                addressForm.state.$invalid = true;
                addressForm.zip_code.$invalid = true;
              } else if (err.message.indexOf('ForceTimeout') > -1) {
                err.message = $translate.instant('common.sales_tax_error').toString();
              }

              $scope.actions.createAlert(err.message, 'danger');
            }
          },
        );
      },
      chooseAddon(addon) {
        const index = $scope.viewmodel.addons.indexOf(addon);

        if (index > -1) {
          $scope.viewmodel.addons.splice(index, 1);
        } else {
          $scope.viewmodel.addons.push(addon);
        }

        $scope.actions.checkAddonPrice();
      },
      checkAddonPrice() {
        // Arcades addon price
        // For plans below 2500 players, Arcades is 80% of the plan price
        $scope.viewmodel.addons.forEach((addon) => {
          if (addon.product_id === 22) {
            if ($scope.viewmodel.plan?.num_players < 2500) {
              addon.price = Math.floor($scope.viewmodel.plan.price * 0.8);
            } else {
              addon.price = addon.original_price;
            }
          }
        });
      },
      chooseGame(game) {
        $scope.actions.resetPromo();

        const index = $scope.viewmodel.games.indexOf(game);

        if (index > -1) {
          $scope.viewmodel.games.splice(index, 1);
        } else {
          $scope.viewmodel.games.push(game);
        }

        // Reset game prices
        $scope.viewmodel.games = $scope.viewmodel.games.map((g) => {
          g.price = $scope.data.bundles[0].price; // single game price
          return g;
        });

        // Update game prices based on bundle price (excluding arcade bundle)
        for (let i = 0; i < $scope.data.bundles.length - 1; i++) {
          if ($scope.viewmodel.games.length >= $scope.data.bundles[i].max_games) {
            $scope.viewmodel.games = $scope.viewmodel.games.map((g, idx) => {
              if (idx < $scope.data.bundles[i].max_games) {
                // only discount games within the bundle
                g.price = $scope.data.bundles[i].price / $scope.data.bundles[i].max_games;
              } else {
                g.price = $scope.data.bundles[0].price; // single game price
              }
              return g;
            });
          }
        }
      },
      subscriptionProductExists() {
        return $scope.data.bundles.find((b) => b.product_id === $scope.viewmodel.subscription.product_id);
      },
      getProducts() {
        productService.getProducts().then((products) => {
          $scope.loading = false;
          $scope.data.games = products.games;
          $scope.data.bundles = products.bundles;
          $scope.data.addons = products.addons;
          $scope.data.addons.forEach((addon) => {
            addon.original_price = addon.price;
          });
        });
      },
      getProrateFactor() {
        const secondsInYear = 60 * 60 * 24 * 365;
        const secondsInDay = 60 * 60 * 24;
        const nowEpoch = new Date().getTime() / 1000;
        const expEpoch = Date.parse($scope.viewmodel.subscription.date_expires) / 1000;
        const secondsRemaining = expEpoch - nowEpoch;
        const ratio = secondsRemaining / secondsInYear;
        const factor = Math.round(ratio * 100) / 100;

        // Don't prorate if subscription ends within 24 hours
        if (expEpoch < nowEpoch + secondsInDay) {
          return false;
        }

        return factor;
      },
      subTotal() {
        let total = 0;

        if ($scope.viewmodel.plan) {
          total += $scope.viewmodel.plan.price;
        }

        if ($scope.viewmodel.games.length) {
          for (let i = 0; i < $scope.viewmodel.games.length; i++) {
            total += $scope.viewmodel.games[i].price;
          }
        }

        if ($scope.viewmodel.addons.length) {
          for (let i = 0; i < $scope.viewmodel.addons.length; i++) {
            total += $scope.viewmodel.addons[i].price;
          }
        }

        if ($scope.viewmodel.service_plan > 0) {
          total += $scope.viewmodel.service_plan * $scope.data.svcPlanPrice;
        }

        if ($scope.viewmodel.admins > 0) {
          total += $scope.viewmodel.admins * $scope.data.adminPrice;
        }

        if ($scope.viewmodel.players > 0) {
          total += $scope.viewmodel.players * $scope.data.playerPrice;
        }

        const prorateFactor = $scope.actions.getProrateFactor();
        if (prorateFactor) {
          $scope.data.isProrating = true;
          total *= prorateFactor;
        } else {
          $scope.data.isProrating = false;
        }

        if ($scope.promo.type === 4 && $scope.promo.paid_amount) {
          total = $scope.promo.paid_amount;
          $scope.data.isProrating = false;
        }

        return total;
      },
      totalTotal() {
        let total = $scope.actions.subTotal();

        // trial, paid and partner promo types are free
        if ($scope.promo.type === 3 || $scope.promo.type === 4 || $scope.promo.type === 5) {
          $scope.promo.discount = total;
        }

        if ($scope.promo.discount > 0) {
          total -= $scope.promo.discount;
        }

        $scope.viewmodel.tax = total * $scope.data.taxRate;

        total += $scope.viewmodel.tax;

        return total > 0 ? Math.round(total) : 0;
      },
      checkout() {
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/modal-checkout.html',
            controller: 'PaymentModalController',
            size: null,
            backdrop: true,
            keyboard: true,
            resolve: {
              extras() {
                return {
                  ...$scope.viewmodel,
                  promo: $scope.promo,
                  total: $scope.actions.totalTotal(),
                  closeButton: true,
                };
              },
            },
          })
          .result.then((response) => {
            if (response === 'success') {
              $scope.actions.createAlert(
                `<span class="fa fa-check"></span> ${$translate.instant('account.subscription_updated_success')}`,
                'success',
              );

              domainService.getSubscription().then((subscription) => {
                $scope.viewmodel.subscription = subscription;
                $scope.viewmodel.games = [];
                $scope.viewmodel.addons = [];
                $scope.viewmodel.code = null;
                $scope.viewmodel.admins = 0;
                $scope.viewmodel.players = 0;
                $scope.viewmodel.service_plan = false;
                $scope.viewmodel.tax = 0;
                $scope.viewmodel.plan = null;
                $scope.actions.resetPromo();
                $scope.actions.getProducts();
                $scope.data.screen = 'address';
              });

              domainService.getDomainStats(true).then((stats) => {
                $scope.viewmodel.stats = stats;
              });
            }
          })
          .catch(angular.noop);
      },
      copySuccess(name) {
        if ($scope.copyTimer) {
          $timeout.cancel($scope.copyTimer);
        }
        $scope.data.copied = name;
        $scope.copyTimer = $timeout(() => {
          $scope.data.copied = false;
        }, 1500);
      },
      toggleTwoFactor() {
        $scope.viewmodel.user.two_factor_enabled = !$scope.viewmodel.user.two_factor_enabled;
      },
    };

    $scope.initialize();
  },
]);
